import axios from 'axios'

export default {
    getCategorySermon(){
        return axios.get('/categorysermon')
            .then(response => {
                return response.data
            })
    },
    getCategorySermonDataSource(params){
        return axios.get('/categorysermon/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getCategorySermonbyID(id){
        return axios.get('/categorysermon/' + id)
            .then(response => {
                return response.data
            })
    },    
    createCategorySermon(formdata){
        return axios.post('/categorysermon', formdata)
            .then(response => {
                return response.data
            })
    },
    updateCategorySermon(id,formdata){
        return axios.put('/categorysermon/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateCategorySermon(id){
        return axios.put('/categorysermon/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateCategorySermon(id){
        return axios.put('/categorysermon/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    destroyCategorySermon(id){
        return axios.delete('/categorysermon/' + id)
            .then(response => {
                return response.data
            })
    },
   
}